import { render, staticRenderFns } from "./Errors.vue?vue&type=template&id=bc2467f4&scoped=true&"
import script from "./Errors.vue?vue&type=script&lang=js&"
export * from "./Errors.vue?vue&type=script&lang=js&"
import style0 from "./Errors.vue?vue&type=style&index=0&id=bc2467f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2467f4",
  null
  
)

export default component.exports